import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select/popular";

export default class extends Controller {
  static values = {
    placeholder: String,
    removeButton: { type: Boolean, default: true },
  };

  connect() {
    const plugins = ["no_backspace_delete"];
    if (this.removeButtonValue) {
      plugins.push("remove_button");
    }

    this.select = new TomSelect(this.element, {
      plugins: plugins,
      placeholder: this.element.dataset.placeholder || "Select...",
      onItemAdd: (value) => {
        this.select.setTextboxValue("");
      },
      onDelete: function (values) {
        return confirm("Are you sure you want to remove this item?");
      },
    });
  }
}
